/**
 * Removes reverse mappings from TypeScript numeric enums.
 */
export function enumToPlain<E extends Record<string, number | string>>(enumObj: E) {
  const entries = Object.entries(enumObj);
  const filtered = entries.filter(([key]) => isNaN(Number(key)));
  return Object.fromEntries(filtered);
}
